import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import type { IReviewsItem } from 'src/components/Reviews/ReviewsItem/ReviewsItem';

import { getIsMobile } from 'src/store/view/selectors';
import { getReviewsLTVisible } from 'src/store/reviews/selectors';
import {
  getCurrentPage,
  getPagesCount,
  getLinkBase,
} from '../../../store/selectors/pagination';

import { ReviewsLevelTravel } from './ReviewsLevelTravel';

const mapStateToProps = (state) => ({
  items: getReviewsLTVisible(state) as Array<IReviewsItem> | undefined,
  isMobile: getIsMobile(state),
  currentPage: getCurrentPage(state),
  pagesCount: getPagesCount(state),
  linkBase: getLinkBase(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ReviewsLevelTravel);
